import { render, staticRenderFns } from "./konsepSuratKeluar.vue?vue&type=template&id=2dc95752&"
import script from "./konsepSuratKeluar.vue?vue&type=script&lang=js&"
export * from "./konsepSuratKeluar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QStepper,QStep,QSelect,QRadio,QFile,QBtnGroup,QStepperNavigation,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QStepper,QStep,QSelect,QRadio,QFile,QBtnGroup,QStepperNavigation,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
